import { parseISO } from 'date-fns';
import { ReactElement, useState } from 'react';

import { toYearMonth } from '~/utils/date/date';
import { IArchivedMedicaidPlan, IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';

import ArchivedPlanMonth from './ArchivedPlanMonth';
import MonthBar from './MonthBar';

import styles from './PlanEngagement.module.scss';

interface IArchivedPlanEngagementProps {
  plan: IArchivedMedicaidPlan;
  client: IMedicaidPlanClient;
}

const ArchivedPlanEngagement = ({ plan, client }: IArchivedPlanEngagementProps): ReactElement => {
  const archiveMonth = toYearMonth(parseISO(plan.archivedOn));
  const [selected, setSelected] = useState(() =>
    plan.expirationDate ? toYearMonth(parseISO(plan.expirationDate)) : archiveMonth,
  );

  return (
    <div className={styles.section}>
      <MonthBar selected={selected} last={archiveMonth} onChange={setSelected} />
      <ArchivedPlanMonth
        key={`${selected.year}-${selected.month}`}
        planId={plan.id}
        client={client}
        selected={selected}
      />
    </div>
  );
};

export default ArchivedPlanEngagement;
